import { Component, ViewChild, ViewContainerRef, Inject, AfterViewInit, OnInit, OnDestroy, Input,Output, Type  } from '@angular/core';
import _ from 'lodash';

import {Tab} from '../../interfaces/mysynch.interfaces';
import {TMTestFarmsView} from '../../pages/tm-dashboard/views/tm-test-farms-view/tm-test-farms-view.component';

@Component({
    standalone: false,
    selector: 'tab-set',
    templateUrl: '../app/content-components/tab-set/tab-set.view.html',
    styleUrls: ['../app/content-components/tab-set/tab-set.style.css']
    })
export class TabSet implements OnInit , OnDestroy{
    @ViewChild('tabViewContainer', { read: ViewContainerRef }) tabViewContainer!: ViewContainerRef;
    
    @Input() tabSetId: string = "tabSet";
    @Input() tabs: Tab[] = [];
    @Input() viewMap: { [key: string]: Type<any> } = {};
    
    private currentViewComponentType: any = null;
    private currentViewComponentRef: any = null;
   

    constructor(@Inject('MySynchFactory') private MSF:any){

    }
    ngOnInit() {
        this.MSF.ready(() => {
            // If no tab is selected, select the first one
             if(_.all(this.tabs, (tab) => !tab.selected) && this.tabs.length > 0){
                 this.selectTab(this.tabs[0]);
             }else{
                    var selectedTab = _.find(this.tabs, (tab) => tab.selected) as Tab;
                    if(_.isUndefined(selectedTab)){
                        selectedTab = this.tabs[0];
                        this.selectTab(selectedTab);
                    }else{
                        this.loadTabContent(selectedTab);
                    }
                    
             }
            
        });
    }
    ngOnDestroy() {
    }
    private resetTab(tab: Tab) {
        tab.selected = false;
    }

    selectTab(tab: Tab) {
        // Deselect previous tab
        let previousTab = _.find(this.tabs, (t) => t.selected);
        if (previousTab) {
            this.resetTab(previousTab);
        }
        tab.selected = true;
        this.loadTabContent(tab);
    }
    
    loadTabContent(tab: Tab) {
        if (this.currentViewComponentRef) {
            this.currentViewComponentRef.destroy();
            this.currentViewComponentRef = null;
        }
        this.currentViewComponentType = this.viewMap[tab.name];
        this.currentViewComponentRef = this.tabViewContainer.createComponent(this.currentViewComponentType);
    }
}